// Verify Account Phone
export const VERIFY_ACCOUNT_PHONE_REQUEST = 'VERIFY_ACCOUNT_PHONE_REQUEST';
export const VERIFY_ACCOUNT_PHONE_DONE = 'VERIFY_ACCOUNT_PHONE_DONE';
export const VERIFY_ACCOUNT_PHONE_FAILED = 'VERIFY_ACCOUNT_PHONE_FAILED';